import {
  DECISIONS_FOLDERS_SET,
  DECISION_FOLDERS_SET,
  DECISION_FOLDER_ADD,
  DECISION_FOLDER_REMOVE,
  MULTIPLE_DECISION_FOLDER_ADD,
} from '../action-types';
import { Folder } from '../../folders.types';
import { DecisionsReducerType } from '../foldersState.types';
import { DecisionActions } from '../actions';

export function decisionsReducer(
  state: DecisionsReducerType = {},
  action: DecisionActions,
) {
  switch (action.type) {
    case DECISION_FOLDERS_SET: {
      return {
        ...state,
        [action.payload.docId]: action.payload.folders.map(
          (folder: Folder) => folder.folderKey,
        ),
      };
    }
    case DECISIONS_FOLDERS_SET: {
      return { ...state, ...action.payload.decisionsFolders };
    }
    case DECISION_FOLDER_ADD: {
      const { docId, folderKey } = action.payload;
      if (!state[docId]) {
        return { ...state, [docId]: [folderKey] };
      }
      if (!state[docId].find((elem: string) => elem === folderKey)) {
        return { ...state, [docId]: state[docId].concat(folderKey) };
      }
      return { ...state };
    }
    case DECISION_FOLDER_REMOVE: {
      const { docId, folderKey } = action.payload;
      return {
        ...state,
        [docId]: state[docId].filter((key: string) => key !== folderKey),
      };
    }
    case MULTIPLE_DECISION_FOLDER_ADD: {
      const { docIds, folderKey } = action.payload;
      return docIds.reduce((acc, docId) => {
        if (!acc[docId]) {
          acc[docId] = [folderKey];
        }
        if (!state[docId].find((elem: string) => elem === folderKey)) {
          return { ...acc, [docId]: state[docId].concat(folderKey) };
        }
        return acc;
      }, state);
    }
    default:
      return state;
  }
}
